import { DevelopmentType } from "@gql/sites-api/graphql";
import { z } from "zod";

export const workspaceSchema = z.object({
  name: z
    .string()
    .min(1, { message: "Workspace name is required" })
    .max(255, { message: "Title must be less than 256 characters" }),
  developmentType: z.nativeEnum(DevelopmentType, { message: "Development type is required" }),
  goal: z.string().max(999, { message: "Goal must be less than 1000 characters" }).optional().or(z.literal("")),
  image: z.string().optional().nullable(),
  imageUrl: z.string().optional().nullable(),
});

export type WorkspaceFormFields = z.infer<typeof workspaceSchema>;
